import { TypeSafeTemplateDelegate } from '../Utility/Handlebars/types';
import videoInfoCompiled from './video_info.hbs';
import './video_info.scss';

interface VideoInfoContext {
    mediaEvents: Array<string>;
}

export const videoInfoTemplate: TypeSafeTemplateDelegate<VideoInfoContext> = videoInfoCompiled;
